<template>
  <QPage class="update-page">
    <AuthTitleBtn
      :title="$t('ETAB.PAGES.STARTUP.WRONG_VERSION.@TITLE', { version: APP_VERSION })"
      :first-btn-label="$t('ETAB.PAGES.STARTUP.WRONG_VERSION.@UPDATE_APP')"
      :second-btn-label="$t('ETAB.PAGES.STARTUP.WRONG_VERSION.@ASK_FOR_HELP')"
      :first-btn-action="update"
      :second-btn-action="askForHelp"
    />
  </QPage>
</template>

<script>
  import { StoresService } from "@core/plugins/mobile";
  import { ContactManager } from "@core/managers/contact.manager";
  import { APP_VERSION } from "@core/constants";
  import AuthTitleBtn from "@etab/components/auth/AuthTitleBtn.component.vue";
  import { JavascriptHelpers } from "@core/helpers";

  export default {
    components: {
      AuthTitleBtn,
    },
    created() {
      this.APP_VERSION = APP_VERSION;
    },
    methods: {
      update() {
        const couldOpenStore = StoresService.openEtabRelevantStore();
        if (!couldOpenStore) {
          JavascriptHelpers.reloadWindow();
        }
      },
      askForHelp() {
        const subject = this.$t("ETAB.PAGES.STARTUP.WRONG_VERSION.@HELP_ME", { version: APP_VERSION });
        ContactManager.contactEtabSupport({ subject });
      },
    },
  };
</script>

<style lang="scss">
  .update-page {
    h2 {
      font-size: 1.2em;
    }
  }
</style>
